import React, { useState } from "react";
import { IconButton } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { useSettingsHook } from "../../../Hooks/communicators/useSettingsHook";

const ImageUploadPreview = ({ imageUrl, which_image }: any) => {
    const {
        handleFileChange,
        file,
        uploading,
        progress,
    } = useSettingsHook();

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="relative w-64 h-96 mb-4">
                {/* Resim önizleme */}
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt="Selected"
                        className="object-cover w-full h-full rounded-lg"
                    />
                ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-lg">
                        <span>Resim Seç</span>
                    </div>
                )}

                {/* İkon butonu */}
                <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                    className="absolute bottom-2 right-2 bg-white shadow-lg"
                >
                    <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => handleFileChange(e, which_image)}
                    />
                    <PhotoCamera />
                </IconButton>
            </div>
        </div>
    );
};

export default ImageUploadPreview;
